/** Primary admin / login domain for Web2POS (admin, dealer, distributor, restaurant portal). */
export const ADMIN_HOST = 'web2pos.com';

/** Legacy subdomain — 301-style redirect to {@link ADMIN_HOST}. */
export const LEGACY_DASHBOARD_HOST = 'dashboard.web2pos.com';

export function adminBaseUrl(): string {
  return `https://${ADMIN_HOST}`;
}

export function isAdminProductionHost(hostname: string): boolean {
  const host = hostname.toLowerCase();
  return host === ADMIN_HOST || host === 'web2pos.web.app';
}

export function isLegacyDashboardHost(hostname: string): boolean {
  return hostname.toLowerCase() === LEGACY_DASHBOARD_HOST;
}

/** Hosts that use web2pos.com Firebase Auth domain + Google redirect persistence. */
export function isAdminAuthHost(hostname: string): boolean {
  return isAdminProductionHost(hostname) || isLegacyDashboardHost(hostname);
}

/** Authenticated portal pages on web2pos.com (login required). */
export function isWeb2posUtilityPath(pathname: string): boolean {
  const path = pathname.replace(/\/$/, '') || '/';
  return path === '/download' || path === '/upload';
}

export function isWeb2posPublicAuthPath(pathname: string): boolean {
  const path = pathname.replace(/\/$/, '') || '/';
  return path === '/login' || path === '/register' || path === '/reset-password';
}
